#import "../../../../../core-entity/widgets/email-sequences-widget/graphql/fragments/drip-progression-fragment.graphql"

fragment LeadDripSequencesFragment on Lead {
    id
    contacts {
        edges {
            node {
                id
                name
                htmlUrl
                dripProgressions {
                    ...DripProgressionFragment
                }
            }
        }
    }
}
